import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PayoutPageContainer from './PayoutPageContainer';
import { actions } from './PayoutPageContainer.actions';
import {
    getHeaderNames,
    getPayouts
} from './PayoutPageContainer.selectors';
import { getPayoutStatuses } from '../../../../selectors/index';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    payouts: getPayouts,
    selectOptions: getPayoutStatuses
});

const PayoutPageContainerComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routing.locationBeforeTransitions,
            loading: state.publisherPayouts.loading,
            totalPages: state.publisherPayouts.total
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getPayouts: actions.getPayouts
        };
    }
)(PayoutPageContainer);

export default PayoutPageContainerComponent;
